import { z } from 'zod';

/**
 * A possible platform for use when tracking analytics (this is how we group our events for analysis)
 */
export type AnalyticsPlatform = 'web' | 'ios' | 'android';

export const analyticsPlatformSchema = z.enum([
  'web',
  'ios',
  'android',
]) satisfies z.ZodType<AnalyticsPlatform>;
